import BaseService from "../../BaseService";

export default class OnboardingService extends BaseService {

  constructor() {
    super('onboarding');
  }

}
